var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueryManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M19.75 19.8665L20.8018 21.0487C20.8813 21.1381 21.0211 21.1381 21.1006 21.0487L23.9167 17.8833",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M23.75 25.55C23.75 25.1358 23.4142 24.8 23 24.8C22.5858 24.8 22.25 25.1358 22.25 25.55H23.75ZM22.25 25.55V26.3737H23.75V25.55H22.25ZM21.3238 27.3H5.67624V28.8H21.3238V27.3ZM4.75 26.3737V6.72623H3.25V26.3737H4.75ZM5.67624 5.79999H10.5V4.29999H5.67624V5.79999ZM4.75 6.72623C4.75 6.21468 5.16469 5.79999 5.67624 5.79999V4.29999C4.33627 4.29999 3.25 5.38625 3.25 6.72623H4.75ZM5.67624 27.3C5.16469 27.3 4.75 26.8853 4.75 26.3737H3.25C3.25 27.7137 4.33627 28.8 5.67624 28.8V27.3ZM22.25 26.3737C22.25 26.8853 21.8353 27.3 21.3238 27.3V28.8C22.6637 28.8 23.75 27.7137 23.75 26.3737H22.25Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M9.25 6C9.25 6.41421 9.58579 6.75 10 6.75C10.4142 6.75 10.75 6.41421 10.75 6H9.25ZM10.75 6V5.67624H9.25V6H10.75ZM11.6762 4.75H13V3.25H11.6762V4.75ZM10.75 5.67624C10.75 5.16469 11.1647 4.75 11.6762 4.75V3.25C10.3363 3.25 9.25 4.33627 9.25 5.67624H10.75Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M17.25 6C17.25 6.41421 17.5858 6.75 18 6.75C18.4142 6.75 18.75 6.41421 18.75 6L17.25 6ZM18 5.67609L17.25 5.67609L18 5.67609ZM18.75 6C18.75 5.88536 18.75 5.77812 18.75 5.67609L17.25 5.67609C17.25 5.77812 17.25 5.88536 17.25 6L18.75 6ZM16.3238 3.25H15V4.75H16.3238V3.25ZM18.75 5.67609C18.75 4.33603 17.6636 3.25 16.3238 3.25V4.75C16.8354 4.75 17.25 5.16463 17.25 5.67609L18.75 5.67609Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 26",
    d: "M15.75 3.49999C15.75 4.46649 14.9665 5.24999 14 5.24999C13.0335 5.24999 12.25 4.46649 12.25 3.49999C12.25 2.5335 13.0335 1.74999 14 1.74999C14.9665 1.74999 15.75 2.5335 15.75 3.49999Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 27",
    d: "M26.7266 19.05C26.7266 21.6733 24.5999 23.8 21.9766 23.8C19.3532 23.8 17.2266 21.6733 17.2266 19.05C17.2266 16.4266 19.3532 14.3 21.9766 14.3C24.5999 14.3 26.7266 16.4266 26.7266 19.05Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 277",
    d: "M11.0859 9.54999H16.0859",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 279",
    d: "M11.0859 13.7167H16.0859",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 281",
    d: "M11.0859 18.7167H14.4193",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 278",
    d: "M11.0859 11.2167H14.4193",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 280",
    d: "M11.0859 15.3833H14.4193",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 282",
    d: "M11.0859 20.55H14.4193",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 710"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_3798_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.91797,
    y: 13.7167,
    width: 2.5,
    height: 2.5,
    rx: 0.670498
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.91797,
    y: 13.7167,
    width: 2.5,
    height: 2.5,
    rx: 0.670498,
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 1.4,
    mask: "url(#path-13-inside-1_3798_2041)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 712"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_3798_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.04999,
    width: 2.5,
    height: 2.5,
    rx: 0.670498
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.04999,
    width: 2.5,
    height: 2.5,
    rx: 0.670498,
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 1.4,
    mask: "url(#path-14-inside-2_3798_2041)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 711"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-3_3798_2041",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.91797,
    y: 17.8833,
    width: 2.5,
    height: 2.5,
    rx: 0.670498
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.91797,
    y: 17.8833,
    width: 2.5,
    height: 2.5,
    rx: 0.670498,
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 1.4,
    mask: "url(#path-15-inside-3_3798_2041)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M22.25 13.05C22.25 13.4642 22.5858 13.8 23 13.8C23.4142 13.8 23.75 13.4642 23.75 13.05H22.25ZM17.5 5.79999H21V4.29999H17.5V5.79999ZM22.25 7.04999V13.05H23.75V7.04999H22.25ZM21 5.79999C21.6904 5.79999 22.25 6.35963 22.25 7.04999H23.75C23.75 5.5312 22.5188 4.29999 21 4.29999V5.79999Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryManagement);
export default __webpack_public_path__ + "static/media/query-management.2b90a5ad81e57604cfd2fa0efdcee0fa.svg";
export { ForwardRef as ReactComponent };